import { DELETE } from "../../helper/collaticaRestFunctions";

export const deleteOrgUser = async (orgId: any, orgUserId: any) => {
  const path = `/orgs/${orgId}/users/${orgUserId}`;
  return await DELETE(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching modules > ", err);
      return err;
    });
};
